import * as React from 'react'
import './Cashier.scss'
import AmtInput from "../../components/AmtInput";
import { ActionType, merchantInfoType, reducerStoreType } from "../../reducers/types";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { ChangeEvent } from "react";
import NumberPad, { keyItem } from "../../components/NumberPad";
import { toast } from "react-toastify";
import { Grid } from '@material-ui/core';
import { injectIntl, IntlShape } from "react-intl";

interface IProps {
  dispatch: Dispatch<ActionType<any>>,
  merchantInfo: merchantInfoType,
  intl: IntlShape
}

interface IState {
  amt: string,
  tradeSummary: string,
  checkcurr: string,
  exchangeRate: number
}


class Cashier extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    // 安全检查 merchantInfo 和 accoutList
    const { merchantInfo } = props;
    const accoutList = merchantInfo && merchantInfo.accoutList ? merchantInfo.accoutList : [];

    // 设置默认货币为 accoutList 中的第一个货币，如果没有则使用 orgCurrency
    const defaultCurrency = accoutList.length > 0
      ? accoutList[0].currency
      : '';

    // 获取默认货币对应的汇率
    const defaultExchangeRate = accoutList.find(item => item.currency === defaultCurrency)
      ? accoutList.find(item => item.currency === defaultCurrency)!.exchangeRate
      : 0;
    this.state = {
      amt: '',
      tradeSummary: '',
      checkcurr: defaultCurrency,
      exchangeRate: defaultExchangeRate
    }
  }
  handleCurrencyChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    console.log(event.target.value)
    const value = event.target.value as string;

    // 获取选中货币对应的利率
    const accoutList = this.props.merchantInfo && this.props.merchantInfo.accoutList ? this.props.merchantInfo.accoutList : [];
    const selectedAccount = accoutList.find(item => item.currency === value);
    const exchangeRate = selectedAccount ? selectedAccount.exchangeRate : 0;
    this.setState({
      checkcurr: value,
      exchangeRate: exchangeRate
    })
  }
  handleAmtChange = (e: ChangeEvent<HTMLInputElement>) => {
    let value = e.currentTarget.value
    // let last = value.substr(value.length - 1, 1)
    if (this.state.checkcurr === 'JPY') {
      // 验证非日元情况下新输入为'.'
      // if(last === '.'){
      //     return value.substr(1)
      // }
      // 验证非0正整数
      let reg = /^\+?[1-9][0-9]*$/
      if (reg.test(value)) {
        this.setState({
          amt: value
        })
      }
      if (value === '') {
        this.setState({
          amt: value
        })
      }
      // else {
      //     this.setState({
      //         amt: ''
      //     })
      // }
    } else {
      // 清除“数字”和“.”,“-”以外的字符
      value = value.replace(/[^\d.-]/g, "");
      // 验证第一个字符不是.
      value = value.replace(/^\./g, "");
      // 当存在连续的多个“.”时，只保留一个
      value = value.replace(/\.{2,}/g, ".");
      // 只保留第一个“.”，清除多余的“.”
      value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      // 当存在连续的多个“-”时，只保留一个
      value = value.replace(/\-{2,}/g, "-");
      // 只保留第一个“-”，清除多余的“-”
      value = value.replace("-", "$#$").replace(/\-/g, "").replace("$#$", "-");
      // 如果行首不是“-”，则不允许有“-”
      if (!(/^\-/.test(value))) {
        value = value.replace("-", "");
      }
      // 只能输入小数点后两位
      value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      this.setState({
        amt: value
      })
    }
  }
  handleRemarkChange = (e: ChangeEvent<HTMLInputElement>) => {
    let value = e.currentTarget.value
    this.setState({
      tradeSummary: value
    })
  }
  handleNumberPadChange = (item: keyItem) => {
    let prevAmt = this.state.amt
    let value = ''
    if (item.action && item.action === 'delete') {
      value = prevAmt.substr(0, prevAmt.length - 1)
    } else {
      value = prevAmt + item.value
    }
    // let last = value.substr(value.length - 1, 1)
    if (this.state.checkcurr === 'JPY') {
      // 验证非日元情况下新输入为'.'
      // if(last === '.'){
      //     return value.substr(1)
      // }
      // 验证非0正整数
      let reg = /^\+?[1-9][0-9]*$/
      if (reg.test(value)) {
        this.setState({
          amt: value
        })
      }
      if (value === '') {
        this.setState({
          amt: value
        })
      }
    } else {
      // 清除“数字”和“.”,“-”以外的字符
      value = value.replace(/[^\d.-]/g, "");
      // 验证第一个字符不是.
      value = value.replace(/^\./g, "");
      // 当存在连续的多个“.”时，只保留一个
      value = value.replace(/\.{2,}/g, ".");
      // 只保留第一个“.”，清除多余的“.”
      value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      // 当存在连续的多个“-”时，只保留一个
      value = value.replace(/\-{2,}/g, "-");
      // 只保留第一个“-”，清除多余的“-”
      value = value.replace("-", "$#$").replace(/\-/g, "").replace("$#$", "-");
      // 如果行首不是“-”，则不允许有“-”
      if (!(/^\-/.test(value))) {
        value = value.replace("-", "");
      }
      // 只能输入小数点后两位
      value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      this.setState({
        amt: value
      })
    }
  }
  checkOrderParam = () => {
    if (!this.state.amt) {
      toast.error(this.props.intl.formatMessage({ id: 'amtNotNull' }))
      return false
    }
    if (Number(this.state.amt) < 0.01 || (this.state.checkcurr.toUpperCase() === 'JPY' && Number(this.state.amt) < 1)) {
      toast.error(this.props.intl.formatMessage({ id: 'amtShouldBeInteger' }))
      return false
    }
    return true
  }
  onConfirm = () => {
    if (this.checkOrderParam()) {
      this.props.dispatch({
        type: 'CREATE_LINK',
        payload: {
          data: {
            amt: this.state.amt,
            tradeSummary: this.state.tradeSummary,
            currency: this.state.checkcurr
          }
        }
      })
    }
  }

  onCancel = () => {
    this.setState({
      amt: '',
      tradeSummary: '',
      checkcurr: '',
      exchangeRate: 0
    })
  }

  getAmtAfterExchange = () => {
    let amt = Number(this.state.amt)
    let { markupRate, orgCurrency } = this.props.merchantInfo
    let exchangeRate = this.state.exchangeRate
    let realAmt = amt * exchangeRate * (1 + markupRate)
    if (orgCurrency.toUpperCase() === 'JPY') {
      return realAmt.toFixed(0)
    } else {
      return realAmt.toFixed(2)
    }
  }
  getExchangeRate = () => {
    return (this.state.exchangeRate * (1 + this.props.merchantInfo.markupRate)).toFixed(6)
  }
  componentDidMount() {
    // 组件挂载后检查 merchantInfo 是否有数据，如果有数据但没有设置默认货币，则设置默认货币
    const { merchantInfo } = this.props;
    const accoutList = merchantInfo && merchantInfo.accoutList ? merchantInfo.accoutList : [];

    if (accoutList.length > 0 && !this.state.checkcurr) {
      const defaultCurrency = accoutList[0].currency;
      const defaultExchangeRate = accoutList[0].exchangeRate;

      this.setState({
        checkcurr: defaultCurrency,
        exchangeRate: defaultExchangeRate
      });

      console.log('componentDidMount: set default currency to', defaultCurrency);
    }
  }

  componentDidUpdate(prevProps: IProps) {
    // 当 merchantInfo 变化时，更新默认货币（只有当当前没有选择货币时）
    const { merchantInfo } = this.props;
    const prevAccoutList = prevProps.merchantInfo && prevProps.merchantInfo.accoutList ? prevProps.merchantInfo.accoutList : [];
    const currAccoutList = merchantInfo && merchantInfo.accoutList ? merchantInfo.accoutList : [];

    // 检查 accoutList 是否有变化
    if (prevAccoutList.length !== currAccoutList.length) {
      console.log('accoutList changed');

      // 如果当前没有选择货币，并且有可用的货币列表，则设置默认货币
      if (!this.state.checkcurr && currAccoutList.length > 0) {
        const defaultCurrency = currAccoutList[0].currency;
        const defaultExchangeRate = currAccoutList[0].exchangeRate;

        this.setState({
          checkcurr: defaultCurrency,
          exchangeRate: defaultExchangeRate
        });

        console.log('componentDidUpdate: set default currency to', defaultCurrency);
      }
    }
  }
  public render() {
    let { exchangeFlag, orgCurrency, currency, accoutList } = this.props.merchantInfo
    let { intl } = this.props
    return (
      <Grid item xs={12} md={6} lg={5} xl={4}>
        <div className="cashier">
          <div className="header">
            <h2>{intl.formatMessage({ id: 'createLink' })}</h2>
            {/* <div className="store">
                            {role === 2 ? 
                                <FormControl className="formControl">
                                    <Label shrink htmlFor="settle-store-select">
                                        {intl.formatMessage({id: 'storeChoose'})}
                                    </Label>
                                    <Select
                                        value={this.state.storeId}
                                        onChange={this.handleStoreChange}
                                        input={<MyInput width={130}  labelmargin={18}  border="none" id="settle-store-select" name="settleStatus"/>}
                                    >
                                        {
                                            storeList.map((item, i) => {
                                                return <MyMenuItem key={`settle-statues-${item.storeId}`}
                                                                    value={item.storeId}>{item.storeName}</MyMenuItem>
                                            })
                                        }
                                    </Select>
                                </FormControl> : null
                            }
                        </div> */}
          </div>
          <div className="container">
            <div className="amtContainer">
              <AmtInput onChange={this.handleAmtChange}
                accoutList={accoutList}
                currency={this.state.checkcurr}
                onCurrencyChange={this.handleCurrencyChange}
                val={this.state.amt} />
              {exchangeFlag ?
                <div className="exchangeRate">1{this.state.checkcurr} ≈ {this.getExchangeRate()}{orgCurrency}</div> : null}
            </div>
            <div className="tips">
              {intl.formatMessage({ id: 'collectAmt' })}({orgCurrency}): {this.getAmtAfterExchange()}
            </div>
            <input className="remarkInput"
              placeholder={intl.formatMessage({ id: 'remark' })}
              value={this.state.tradeSummary}
              onChange={this.handleRemarkChange} />
            <NumberPad onChange={this.handleNumberPadChange} />
            <div className={`buttons`}>
              <button className="transQr" onClick={this.onConfirm}>
                {intl.formatMessage({ id: 'confirm' })}
              </button>
              <button className="scanQr" onClick={this.onCancel}>
                {intl.formatMessage({ id: 'cancel' })}
              </button>
            </div>
          </div>
        </div>
      </Grid>);
  }
}

export default injectIntl(connect((state: reducerStoreType, props) => {
  return {
    merchantInfo: state.merchant.merchantInfo
  }
})(Cashier))